import { PlainButton, MultiSectionLayout } from "@jugl-web/ui-components";
import { FC, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { CXCreditsTile } from "@web-src/modules/cx/components/CXCreditsTile";
import { ReactComponent as GeneralIcon } from "./assets/general.svg";
import { ReactComponent as PlansIcon } from "./assets/plans.svg";
import { ReactComponent as TeamMembersIcon } from "./assets/team-members.svg";

interface CXAdminSidebarProps {
  children?: ReactNode;
}

export const CXAdminSidebar: FC<CXAdminSidebarProps> = ({ children }) => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();

  return (
    <MultiSectionLayout
      className="h-[calc(100vh-108px)]"
      classNames={{
        leftSide:
          "w-[240px] border-y-0 border-l-0 border-r border-solid border-r-[#E0E2E3] bg-white",
        content: "jugl__custom-scrollbar",
      }}
      leftSide={
        <aside className="flex h-full flex-col">
          <nav className="flex flex-1 flex-col gap-3 overflow-y-auto px-2 py-3">
            <NavItem
              label={t({
                id: "cx-admin-sidebar.general",
                defaultMessage: "General",
              })}
              icon={<GeneralIcon />}
              onClick={() => navigateToPage("cxWorkspaceGeneral")}
              pathSegment="general"
            />
            <NavItem
              label={t({
                id: "cx-admin-sidebar.plans",
                defaultMessage: "Plans",
              })}
              icon={<PlansIcon />}
              onClick={() => navigateToPage("cxWorkspacePlans")}
              pathSegment="plans"
            />
            <NavItem
              label={t({
                id: "cx-admin-sidebar.team-members",
                defaultMessage: "Team Members",
              })}
              icon={<TeamMembersIcon />}
              onClick={() => navigateToPage("cxWorkspaceTeamMembers")}
              pathSegment="team-members"
            />
          </nav>

          <CXCreditsTile theme="light" />
        </aside>
      }
    >
      {children}
    </MultiSectionLayout>
  );
};

interface NavItemProps {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  pathSegment: string;
}

const NavItem: FC<NavItemProps> = ({ label, icon, onClick, pathSegment }) => {
  const { pathname } = useLocation();
  const isActive = pathname.includes(pathSegment);

  return (
    <PlainButton
      onClick={onClick}
      className={`flex h-12 w-full items-center gap-1 rounded-lg px-1 transition-colors ${
        isActive
          ? "bg-[#F9F9F9] text-[#1A2023]"
          : "text-[#4F4F4F] hover:bg-[#F9F9F9]"
      }`}
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center">
        {icon}
      </span>
      <span className="font-secondary text-sm">{label}</span>
    </PlainButton>
  );
};
